import config from './config.js'

export default {
  viewparams: {"rows":20,"page":1,"sidx":'id',"sord":'asc'},

  // list
  list: function(cb_success) {
    var u = config.baseUrl + 'rest/security/users?rows=' + this.viewparams.rows + '&page=' + this.viewparams.page + '&sidx=' + this.viewparams.sidx + '&sord=' + this.viewparams.sord;
    fetch(u,{credentials:'include'}).then(resp => resp.json()).then(cb_success);
  },

  load: function(id,cb_success) {
    var u = config.baseUrl + 'rest/security/users/' + encodeURIComponent(id);
    fetch(u,{credentials:'include'}).then(resp => resp.json()).then(cb_success);
  },

  deleteUser: function(ctrl,id,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/security/users/' + encodeURIComponent(id),'Benutzer löschen',cb_success);
  },

  getroles: function(ctrl,id,cb_success) {
    var u = config.baseUrl + 'rest/security/roles/' + encodeURIComponent(id);
    config.get(ctrl,u,'Benutzerrollen laden.',cb_success);
  },

  saveroles: function(ctrl,id,roles,cb_success) {
    var u = config.baseUrl + 'rest/security/roles/' + encodeURIComponent(id);
    config.post(ctrl,u,'Benutzerrollen speichern.',JSON.stringify(roles),cb_success);
  },


  availableRoles() {
    return fetch(config.baseUrl + 'rest/security/roles').then(resp => resp.json());
  },

  save: function(ctrl,data,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/security/users','Benutzer speichern',JSON.stringify(data),cb_success);
  },

  logindata: function(ctrl,id,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/security/logins/' + encodeURIComponent(id),'Login laden',cb_success);
  },

  savelogin: function(ctrl,login,cb_success) {
    config.post(ctrl,config.baseUrl + 'rest/security/logins','Login speichern.',JSON.stringify(login),cb_success);
  },

  // user tasks info laden
  taskinfo: function(role,cb_success) {
    var u = config.baseUrl + 'rest/wf/tasks?role=admin';
    fetch(u,{credentials:'include'}).then(resp => resp.json()).then(cb_success);
  },

  listapikeys: function(ctrl,uid,cb_success) {
    config.get(ctrl,config.baseUrl + 'rest/security/apikeys/' + encodeURIComponent(uid),'API Keys laden',cb_success);
  },

  createapikey: function(ctrl,uid,cb_success) {
    config.put(ctrl,config.baseUrl + 'rest/security/apikeys/' + encodeURIComponent(uid),'API Key erstellen','',cb_success);
  },

  deleteapikey: function(ctrl,uid,kid,cb_success) {
    config.delete(ctrl,config.baseUrl + 'rest/security/apikeys/' + encodeURIComponent(uid) + "/" + encodeURIComponent(kid),'API Key löschen',cb_success);
  }

}
